import $ from 'jquery';

window.addEventListener("load", () => {
  if (document.getElementById("next_link")) {
    const element = document.querySelector("#next_link");
    element.addEventListener("ajax:beforeSend", () => {
      $("body").css("cursor", "progress");
    });
  }
});
